import { StateType } from '../../index';

export const eventsDataSelector = (state: StateType) => state.getIn(['dashboard', 'events', 'data']);
export const eventsIsFetchingSelector = (state: StateType) => state.getIn(['dashboard', 'events', 'isFetching']);
